export default __webpack_public_path__ + "static/media/2340.72b87335.png";